import React from 'react';
import {
  Icon, Spinner
} from '@blueprintjs/core';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { WorkOrderPill } from 'components/Job/recordPills';
import JobEmpty from 'components/Job/JobEmpty';

const initialsOf = (name = '') =>
  String(name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('');

@inject('viewStore', 'jobStore') @observer
class WorkOrdersTable extends React.Component {

  @observable workReports = {
    isLoading: true,
    objects: []
  }

  render() {
    let { 
      jobStore: {
        jobWorkReports,
        jobAssociations: {
          isLoading
        }
      } 
    } = this.props
    const {
      viewStore
    } = this.props;
    if (isLoading) {
      return <div className="spinner-center"><Spinner size='25' /></div>
    }
    if (jobWorkReports.length === 0) {
      return (
        <JobEmpty kind="work-orders" />
      )
    }
    return (
      <div className="">
          {
            jobWorkReports.map((workReport) => {
              return (
                <div className="tabs-data-card" key={workReport.id} onClick={() => {viewStore.ShowWorkOrder({ uuid: workReport.attributes.id})}}>
                  <div className="card-style">
                    <div width="10px" className="customer-avatar">
                      <span className="jp-initials" aria-hidden="true">{initialsOf(workReport.attributes.created_by.full_name)}</span>
                    </div>
                    <div className="job-number" width="150px">
                      <p className="secondary">#{workReport.attributes.number}</p>
                      <p className="primary">By {workReport.attributes.created_by.full_name}</p>
                    </div>
                  </div>
                  <div className="job-details-status">
                    <div className="status-alignment">
                      <WorkOrderPill attributes={workReport.attributes} />
                    </div>
                    <div className="job-date-time">
                      {/* <p className='time-entry primary'>{this.calculateTotal(workReport)}</p> */}
                      <p className='secondary'>{workReport.attributes.formatted_created_at}</p>
                    </div>
                  </div>
                  {/* <div>
                    <Icon icon="caret-right" />
                  </div> */}
                </div>
              )
            })
          }
        </div>
    )
  }
}

export default WorkOrdersTable;